import React from 'react';
import { Bar } from 'react-chartjs-2';

function BusinessMetrics() {
  const data = {
    labels: ['Business A', 'Business B', 'Business C'],
    datasets: [
      {
        label: 'Revenue (Millions)',
        data: [12, 19, 3],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(75, 192, 192, 0.2)'
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(75, 192, 192, 1)'
        ],
        borderWidth: 1
      }
    ]
  };

  return (
    <div className="business-metrics">
      <Bar data={data} />
      <p>Total Revenue: $34M</p>
    </div>
  );
}

export default BusinessMetrics;
